import {apolloClient} from '@/setup/apollo-setup'
import axios from 'axios'
import {config} from '@/utils/upload'
import {
  CALL_HISTORIES_RECEIVED,
  CALL_HISTORIES_RECEIVED_BY_IDS,
  CALL_HISTORIES_UN_RECEIVED,
  CALL_HISTORIES_UN_RECEIVED_ALL,
  CALL_HISTORIES_UN_RECEIVED_BY_USER_ID,
  CONTRACT_IDS_SIGN_IN_STUDENT_APP,
  CREATE_CALL_HISTORY,
  CREATE_CONTRACT,
  CREATE_FEE_DETAIL,
  CREATE_FILE,
  CREATE_INTEREST_RATE_DETAIL,
  CREATE_LAW_SUIT_HISTORY,
  CREATE_LOAN_DETAIL,
  CREATE_LOAN_DETAIL_PLAN,
  CREATE_PAYMENT,
  CREATE_PAYMENT_CONTRACT_FEE,
  CREATE_PAYMENT_ROUND,
  CREATE_PAYMENT_ROUNDS,
  CREATE_PAYMENT_TAX_AMOUNT,
  CREATE_PAYMENTS,
  CREATE_QR_PAYMENT,
  CREATE_RECEIPTS,
  CREATE_SEND_DOC_HISTORY,
  CREATE_SEND_SMS_HISTORY,
  CREATE_SURETY_DETAIL,
  CREATE_TRANSACTION,
  CREATE_TRANSACTIONS,
  DELETE_CALL_HISTORY,
  DELETE_CONTRACT,
  DELETE_FEE_DETAIL,
  DELETE_FILE,
  DELETE_INTEREST_RATE_DETAIL,
  DELETE_LAW_SUIT_HISTORY,
  DELETE_LOAN_DETAIL,
  DELETE_LOAN_DETAIL_PLAN,
  DELETE_PAYMENT,
  DELETE_PAYMENT_ROUND,
  DELETE_PAYMENT_ROUNDS,
  DELETE_PAYMENTS,
  DELETE_PAYMENTS_BY_CONTRACT_ID,
  DELETE_SEND_DOC_HISTORY,
  DELETE_SEND_SMS_HISTORY,
  DELETE_SURETY_DETAIL,
  DELETE_TRANSACTION,
  DELETE_TRANSACTION_EIRS,
  DELETE_TRANSACTION_EIRS_BY_CONTRACT_ID_AND_TRANSACTION_DATE,
  DELETE_TRANSACTIONS,
  DELETE_TRANSACTIONS_BY_CONTRACT_ID_AND_TRANSACTION_DATE,
  FORCE_DELETE_CONTRACT,
  GET_CONTRACT,
  GET_CONTRACT_EDIT,
  GET_CONTRACT_FILES,
  GET_CONTRACT_NO,
  GET_CONTRACT_OPTIONS,
  GET_CONTRACT_OPTIONS_FOR_PROSECUTION,
  GET_CONTRACT_PAYMENTS,
  GET_CONTRACT_WITH_OUT_AUTH,
  GET_CONTRACTS,
  GET_CONTRACTS_PROCESS_LOCKED,
  GET_CONTRACTS_BY_DASHBOARD_LIST,
  GET_CONTRACTS_BY_FILTERS,
  GET_CONTRACTS_BY_NOTIFICATION_LIST,
  GET_CONTRACTS_CREATED_BY_CURRENT_USER,
  GET_CONTRACTS_TRACK_DOWN_DEBT_BY_FILTERS,
  GET_DASHBOARD,
  GET_FEE_DETAIL,
  GET_FEE_DETAILS,
  GET_FILE,
  GET_FILES,
  GET_INTEREST_RATE_DETAIL,
  GET_INTEREST_RATE_DETAILS,
  GET_LOAN_DETAIL,
  GET_LOAN_DETAIL_PLAN,
  GET_LOAN_DETAIL_PLANS,
  GET_LOAN_DETAIL_PLANS_BY_CONTRACT_ID,
  GET_LOAN_DETAILS,
  GET_NOTIFICATION_CONTRACT_SMART_APP,
  GET_PAYMENT,
  GET_PAYMENT_ROUND,
  GET_PAYMENT_ROUNDS,
  GET_PAYMENTS,
  GET_PAYMENTS_BY_CONTRACT_ID,
  GET_RESTRUCTURING_DETAIL_BY_DATE,
  GET_SURETY_DETAIL,
  GET_SURETY_DETAIL_WITH_OUT_AUTH,
  GET_SURETY_DETAILS,
  GET_TRANSACTION,
  GET_TRANSACTION_EIR,
  GET_TRANSACTION_EIRS,
  GET_TRANSACTION_EIRS_BY_CONTRACT_ID,
  GET_TRANSACTIONS,
  GET_TRANSACTIONS_BY_CONTRACT_ID,
  IMPORT_BAD_DEBTS,
  IMPORT_CONTRACT_SURETIES,
  IMPORT_CONTRACTS,
  IMPORT_LOAN_DETAIL_PLANS,
  IMPORT_LOAN_DETAILS,
  IMPORT_PAYMENTS,
  IMPORT_TRACK_DOWN_DEBTS,
  RE_GENERATE_TRANSACTION_EIRS,
  RE_GENERATE_TRANSACTIONS,
  RESET_FEE_DETAILS,
  SET_EDUCATION_STATUS,
  UPDATE_CONTRACT,
  UPDATE_CONTRACT_STATUS,
  UPDATE_FEE_DETAIL,
  UPDATE_FILE,
  UPDATE_FILE_WITH_OUT_AUTH,
  UPDATE_INTEREST_RATE_DETAIL,
  UPDATE_LOAN_DETAIL,
  UPDATE_LOAN_DETAIL_PLAN,
  UPDATE_PAYMENT,
  UPDATE_PAYMENT_ROUND,
  UPDATE_SURETY_DETAIL,
  UPDATE_TRANSACTION,
} from '@/queries/modules/accounting'

// import {
//   GET_CONTRACT_DETAIL,
// } from '@/queries/modules/accounting/contractDetail'
import {addItemSuccess, deleteItemSuccess, error, updateItemSuccess,} from '@/utils/notification'

export * from './contractDetail'

export async function initializing(context, payload) {
  context.commit('setInitializing', payload)
}

export async function importContracts(context, payload) {
  // console.log('Add importContracts...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    meta: payload.meta,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: IMPORT_CONTRACTS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = response
    const {importContracts} = data
    return importContracts
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
    return []
  }
}

export async function importLoanDetails(context, payload) {
  // console.log('Add ImportJob...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    meta: payload.meta,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: IMPORT_LOAN_DETAILS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = response
    const {importLoanDetails} = data
    return importLoanDetails
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
    return []
  }
}

export async function importLoanDetailPlans(context, payload) {
  // console.log('Add ImportJob...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    meta: payload.meta,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: IMPORT_LOAN_DETAIL_PLANS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = response
    const {importLoanDetailPlans} = data
    return importLoanDetailPlans

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
    return []
  }
}

export async function importPayments(context, payload) {
  // console.log('Add ImportJob...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    meta: payload.meta,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: IMPORT_PAYMENTS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = response
    const {importPayments} = data
    return importPayments
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
    return []
  }
}

export async function importTrackDownDebts(context, payload) {
  // console.log('Add ImportJob...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    meta: payload.meta,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: IMPORT_TRACK_DOWN_DEBTS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = response
    const {importTrackDownDebts} = data
    return importTrackDownDebts
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
    return []
  }
}

export async function importContractsSureties(context, payload) {
  // console.log('Add ImportJob...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    meta: payload.meta,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: IMPORT_CONTRACT_SURETIES,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = response
    const {importContractsSureties} = data
    return importContractsSureties
  } catch (e) {
    context.commit('setError', error(e.toString(), null));
    return []
  }
}

export async function importBadDebts(context, payload) {
  // console.log('Add ImportJob...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    meta: payload.meta,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: IMPORT_BAD_DEBTS,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = response
    const {importBadDebts} = data
    return importBadDebts
  } catch (e) {
    context.commit('setError', error(e.toString(), null));
    return []
  }
}

export async function getContractNo(context, payload) {
  // console.log('Get Contract No...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    borrowerId: payload.form.borrowerId
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACT_NO,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response

    context.commit('setContractNo', data.getContractNo.contractNo)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContract(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {id: payload.form.id}
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACT,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContract} = await data
    // console.log(getContract);
    context.commit('setContract', getContract)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractTransactionManage(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {id: payload.form.id}
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACT,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContract: contract} = await data

    context.commit('setContract', contract)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractTransactionManageRefresh(context, payload) {
  // console.log('Get Contract...')
  context.commit('clearError')

  const variables = {
    id: payload.form.id
  }

  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACT,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContract: contract} = await data

    context.commit('setContract', contract)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractEdit(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {id: payload.form.id}
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACT_EDIT,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContract} = await data
    context.commit('setContract', getContract)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractWithOutAuth(context, payload) {
  // console.log('Get SuretyDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id,
      token: payload.form.token,
    }
    const response = await apolloClient
      .query({
        query: GET_CONTRACT_WITH_OUT_AUTH,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getContractWithOutAuth} = await data
    context.commit('setContractWithOutAuth', getContractWithOutAuth)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationContractSale(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {id: payload.form.id}
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_CONTRACT_SMART_APP,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContract} = await data

    context.commit('setContractSuretyAppointment', getContract)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractFiles(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {id: payload.form.id}
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACT_FILES,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setContractFiles', data.getContract)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContracts(context) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACTS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContracts: contracts} = data
    context.commit('setContracts', contracts)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractOptions(context, payload) {
  // console.log('Get Contract Options...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = payload ? {
    payload: payload
  } : {payload: {}}

  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACT_OPTIONS,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContractsByFilters: contractOptions} = data
    // console.log(response)

    context.commit('setContractOptions', contractOptions)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractOptionsForProsecution(context, payload) {
  // console.log('Get Contract Options...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = payload ? {
    payload: payload
  } : {payload: {}}

  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACT_OPTIONS_FOR_PROSECUTION,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContractsByFilters: contractOptions} = data

    context.commit('setContractOptions', contractOptions)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function setContractOptions(context, payload) {
  // console.log('Set Contract Options...')

  context.commit('setContractOptions', payload ? payload : [])
}

export async function getContractsCreatedByCurrentUser(context) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACTS_CREATED_BY_CURRENT_USER,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContractsCreatedByCurrentUser: contracts} = data
    context.commit('setContracts', contracts)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractsProcessLocked(context) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACTS_PROCESS_LOCKED,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    // console.log(data.getContractsProcessLocked)
    context.commit('setContracts', data.getContractsProcessLocked)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractsByFilters(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACTS_BY_FILTERS,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setContractsByFilters', data.getContractsByFilters)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractsTrackDownDebtByFilters(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  context.commit('clearContract')
  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACTS_TRACK_DOWN_DEBT_BY_FILTERS,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    // console.log(data.getContractsTrackDownDebtByFilters)
    context.commit('setContractsTrackDownDebtByFilters', data.getContractsTrackDownDebtByFilters)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createContract(context, payload) {
  // console.log('Add Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {createContract} = data
    context.commit('setSuccess', addItemSuccess({}))

    setTimeout(() => {
      vm.$router.push({name: 'accounting-contract-detail', params: {id: createContract.id}});
    }, 200);
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateContract(context, payload) {
  // console.log('Create Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    reCalculate: payload.reCalculate,
    payload: payload.form
  }
  try {
    // console.log("variables ", variables)
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CONTRACT,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {updateContract} = data

    context.commit('setContract', updateContract)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateContractStatus(context, payload) {
  // console.log('Create Contract Status...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CONTRACT_STATUS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {updateContractStatus} = data
    context.commit('setContract', updateContractStatus)
    context.commit('setSuccess', updateItemSuccess({}))
    return updateContractStatus
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function clearContract(context) {
  // console.log('Clear Contract...')
  context.commit('clearContract')
}

export async function setEducationStatus(context, payload) {
  // console.log('Create Contract Status...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: SET_EDUCATION_STATUS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('setContract', data.setEducationStatus)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContract(context, payload) {
  // console.log('Delete Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data: {deleteContract}} = await response
    context.commit('delContract', deleteContract)
    context.commit('setContractsByFilters', [])
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function forceDeleteContract(context, payload) {
  // console.log('Delete Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: FORCE_DELETE_CONTRACT,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delContract', data.forceDeleteContract)
    context.commit('setContractsByFilters', [])
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getRestructuringDetailByDate(context, payload) {
  // console.log('Get Restructuring Detail By Date...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id,
    restructuringDate: payload.form.restructuringDate
  }
  const variables2 = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_RESTRUCTURING_DETAIL_BY_DATE,
        variables,
        fetchPolicy: 'network-only'
      })
    const {
      data: {
        getRestructuringDetailByDate
      }
    } = await response

    const response2 = await apolloClient
      .query({
        query: GET_CONTRACT_PAYMENTS,
        variables: variables2,
        fetchPolicy: 'network-only'
      })
    const {data: {getContract}} = await response2
    // console.log(getContract);
    context.commit('setContractPayments', getContract)
    context.commit('setSuccess', null)
    return getRestructuringDetailByDate
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getInterestRateDetail(context, payload) {
  // console.log('Get InterestRateDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }

  try {
    const response = await apolloClient
      .query({
        query: GET_INTEREST_RATE_DETAIL,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setInterestRateDetail', data.getInterestRateDetail)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getInterestRateDetails(context) {
  // console.log('Get InterestRateDetails...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_INTEREST_RATE_DETAILS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setInterestRateDetails', data.getInterestRateDetails)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createInterestRateDetail(context, payload) {
  // console.log('Add InterestRateDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_INTEREST_RATE_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addInterestRateDetails', data.createInterestRateDetail)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateInterestRateDetail(context, payload) {
  // console.log('Create InterestRateDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
    id: payload.id,
    reCalculate: payload.reCalculate,
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_INTEREST_RATE_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))

    setTimeout(() => {
      vm.$router.push("/accounting/contract")
    }, 200);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteInterestRateDetail(context, payload) {
  // console.log('Delete InterestRateDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_INTEREST_RATE_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delInterestRateDetail', data.deleteInterestRateDetail)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getLoanDetail(context, payload) {
  // console.log('Get LoanDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_LOAN_DETAIL,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setLoanDetail', data.getLoanDetail)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getLoanDetails(context) {
  // console.log('Get LoanDetails...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_LOAN_DETAILS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setLoanDetails', data.getLoanDetails)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createLoanDetail(context, payload) {
  // console.log('Add LoanDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_LOAN_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addLoanDetails', data.createLoanDetail)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateLoanDetail(context, payload) {
  // console.log('Create LoanDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
    id: payload.id,
    reCalculate: payload.reCalculate,
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_LOAN_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))

    setTimeout(() => {
      vm.$router.push("/accounting/contract")
    }, 200);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteLoanDetail(context, payload) {
  // console.log('Delete LoanDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_LOAN_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delLoanDetail', data.deleteLoanDetail)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getLoanDetailPlan(context, payload) {
  // console.log('Get LoanDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_LOAN_DETAIL_PLAN,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setLoanDetailPlan', data.getLoanDetailPlan)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getLoanDetailPlans(context) {
  // console.log('Get LoanDetails...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_LOAN_DETAIL_PLANS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setLoanDetailPlans', data.getLoanDetailPlans)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getLoanDetailPlansByContractId(context, payload) {
  // console.log('Get LoanDetails...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_LOAN_DETAIL_PLANS_BY_CONTRACT_ID,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    // console.log(data.getLoanDetailPlansByContractId)
    context.commit('setLoanDetailPlans', data.getLoanDetailPlansByContractId)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createLoanDetailPlan(context, payload) {
  // console.log('Add LoanDetailPlan...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_LOAN_DETAIL_PLAN,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addLoanDetailPlan', data.createLoanDetailPlan)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateLoanDetailPlan(context, payload) {
  // console.log('Create LoanDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    reCalculate: payload.reCalculate,
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_LOAN_DETAIL_PLAN,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))

    // setTimeout(() => {
    //   vm.$router.push("/accounting/contract")
    // }, 200);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteLoanDetailPlan(context, payload) {
  // console.log('Delete LoanDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_LOAN_DETAIL_PLAN,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delLoanDetailPlan', data.deleteLoanDetailPlan)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getFeeDetail(context, payload) {
  // console.log('Get FeeDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_FEE_DETAIL,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setFeeDetail', data.getFeeDetail)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getFeeDetails(context) {
  // console.log('Get FeeDetails...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_FEE_DETAILS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setFeeDetails', data.getFeeDetails)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createFeeDetail(context, payload) {
  // console.log('Add FeeDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_FEE_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addFeeDetails', data.createFeeDetail)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateFeeDetail(context, payload) {
  // console.log('Create FeeDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
    id: payload.id,
    reCalculate: payload.reCalculate,
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_FEE_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))

    setTimeout(() => {
      vm.$router.push("/accounting/contract")
    }, 200);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteFeeDetail(context, payload) {
  // console.log('Delete FeeDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_FEE_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delFeeDetail', data.deleteFeeDetail)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function resetFeeDetails(context, payload) {
  // console.log('Add FeeDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: RESET_FEE_DETAILS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('setFeeDetails', data.resetFeeDetails)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getPaymentRound(context, payload) {
  // console.log('Get PaymentRound...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_PAYMENT_ROUND,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setPaymentRound', data.getPaymentRound)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getPaymentRounds(context) {
  // console.log('Get PaymentRounds...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_PAYMENT_ROUNDS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setPaymentRounds', data.getPaymentRounds)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createPaymentRound(context, payload) {
  // console.log('Add PaymentRound...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PAYMENT_ROUND,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addPaymentRounds', data.createPaymentRound)
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createPaymentRounds(context, payload) {
  // console.log('Add PaymentRounds...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PAYMENT_ROUNDS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('setPaymentRounds', data.createPaymentRounds)
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updatePaymentRound(context, payload) {
  // console.log('Create PaymentRound...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
    id: payload.id,
    reCalculate: payload.reCalculate,
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_PAYMENT_ROUND,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))

    setTimeout(() => {
      vm.$router.push("/accounting/contract")
    }, 200);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deletePaymentRound(context, payload) {
  // console.log('Delete PaymentRound...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_PAYMENT_ROUND,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delPaymentRound', data.deletePaymentRound)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deletePaymentRounds(context, payload) {
  // console.log('Delete PaymentRound...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_PAYMENT_ROUNDS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {deletePaymentRounds} = data
    context.commit('delPaymentRounds', deletePaymentRounds)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// ===========================================================

export async function getTransaction(context, payload) {
  // console.log('Get Transaction...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_TRANSACTION,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setTransaction', data.getTransaction)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getTransactions(context) {
  // console.log('Get Transactions...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_TRANSACTIONS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setTransactions', data.getTransactions)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getTransactionsByContractId(context, payload) {
  // console.log('Get PaymentRoundTransactions...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_TRANSACTIONS_BY_CONTRACT_ID,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getTransactionsByContractId: transactions} = data;
    context.commit('setTransactions', transactions)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getTransactionsByContractIdRefresh(context, payload) {
  // console.log('Get PaymentRoundTransactions...')

  context.commit('clearError')

  const variables = {
    contractId: payload.contractId,
    filter: "action"
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_TRANSACTIONS_BY_CONTRACT_ID,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getTransactionsByContractId: transactions} = data;
    context.commit('setTransactions', transactions)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createTransaction(context, payload) {
  // console.log('Add Transaction...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_TRANSACTION,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addTransactions', data.createTransaction)
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createTransactions(context, payload) {
  // console.log('Add Transactions...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_TRANSACTIONS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('setTransactions', data.createTransactions)
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateTransaction(context, payload) {
  // console.log('Create Transaction...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
    id: payload.id,
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_TRANSACTION,
        variables,
        fetchPolicy: 'no-cache'
      })

    context.commit('setSuccess', updateItemSuccess({}))

    setTimeout(() => {
      vm.$router.push("/accounting/contract")
    }, 200);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteTransaction(context, payload) {
  // console.log('Delete Transaction...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_TRANSACTION,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delTransaction', data.deleteTransaction)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteTransactions(context, payload) {
  // console.log('Delete TransactionRoundTransactions...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    await apolloClient
      .mutate({
        mutation: DELETE_TRANSACTIONS,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setTransactions', [])
    context.commit('setSuccess', updateItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function reGenerateTransactions(context, payload) {
  // console.log('Add Transaction...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.form.contractId,
    updateToNow: payload.form.updateToNow,
    index: 1
  }
  try {
    apolloClient
      .mutate({
        mutation: RE_GENERATE_TRANSACTIONS,
        variables,
        fetchPolicy: 'no-cache'
      }).then();
    // const  {data} = await response
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteTransactionsByContractIdAndTransactionDate(context, payload) {
  // console.log('Delete TransactionRoundTransactions...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      contractId: payload.contractId,
      transactionDate: payload.transactionDate,
      extra: payload.extra,
    }
    // console.log(variables)
    await apolloClient
      .mutate({
        mutation: DELETE_TRANSACTIONS_BY_CONTRACT_ID_AND_TRANSACTION_DATE,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// ==============================================================

export async function getTransactionEir(context, payload) {
  // console.log('Get TransactionEir...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_TRANSACTION_EIR,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setTransaction', data.getTransactionEir)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getTransactionEirs(context) {
  // console.log('Get TransactionEirs...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_TRANSACTION_EIRS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setTransactions', data.getTransactionEirs)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getTransactionEirsByContractId(context, payload) {
  // console.log('Get PaymentRoundTransactionEirs...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_TRANSACTION_EIRS_BY_CONTRACT_ID,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    // console.log(data.getTransactionEirsByContractId)
    context.commit('setTransactions', data.getTransactionEirsByContractId)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getTransactionEirsByContractIdRefresh(context, payload) {
  // console.log('Get PaymentRoundTransactionEirs...')

  context.commit('clearError')

  const variables = {
    contractId: payload.contractId,
    filter: "action"
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_TRANSACTION_EIRS_BY_CONTRACT_ID,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    // console.log(data.getTransactionEirsByContractId)
    context.commit('setTransactions', data.getTransactionEirsByContractId)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteTransactionEirs(context, payload) {
  // console.log('Delete TransactionEirs...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    await apolloClient
      .mutate({
        mutation: DELETE_TRANSACTION_EIRS,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setTransactions', [])
    context.commit('setSuccess', updateItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function reGenerateTransactionEirs(context, payload) {
  // console.log('Add TransactionEir...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.form.contractId,
    updateToNow: payload.form.updateToNow,
    index: 1
  }
  try {
    apolloClient
      .mutate({
        mutation: RE_GENERATE_TRANSACTION_EIRS,
        variables,
        fetchPolicy: 'no-cache'
      })
    // const {data} = await response
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteTransactionEirsByContractIdAndTransactionDate(context, payload) {
  // console.log('Delete TransactionEirRoundTransactions...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      contractId: payload.contractId,
      transactionDate: payload.transactionDate,
      extra: payload.extra,
    }
    // console.log(variables)
    await apolloClient
      .mutate({
        mutation: DELETE_TRANSACTION_EIRS_BY_CONTRACT_ID_AND_TRANSACTION_DATE,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// ==============================================================
export async function getPayment(context, payload) {
  // console.log('Get Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_PAYMENT,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setPayment', data.getPayment)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getPayments(context) {
  // console.log('Get Payments...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
    const response = await apolloClient
      .query({
        query: GET_PAYMENTS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setPayments', data.getPayments)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getPaymentsByContractId(context, payload) {
  // console.log('Get PaymentRoundPayments...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    date: payload.date
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_PAYMENTS_BY_CONTRACT_ID,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getPaymentsByContractId: payments} = data;
    context.commit('setSuccess', null)
    return payments
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createPayment(context, payload) {
  // console.log('Add Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    updateToNow: payload.updateToNow,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PAYMENT,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addPayments', data.createPayment)
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createPayments(context, payload) {
  // console.log('Add Payments...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PAYMENTS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('setPayments', data.createPayments)
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updatePayment(context, payload) {
  // console.log('Create Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
    id: payload.id,
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_PAYMENT,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))

    setTimeout(() => {
      vm.$router.push("/accounting/contract")
    }, 200);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deletePayment(context, payload) {
  // console.log('Delete Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_PAYMENT,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delPayment', data.deletePayment)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function deletePayments(context, payload) {
  // console.log('Delete Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_PAYMENTS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delPayments', data.deletePayments)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function deletePaymentsByContractId(context, payload) {
  // console.log('Delete Payments By ContractId...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      contractId: payload.form.id
    }

    await apolloClient
      .mutate({
        mutation: DELETE_PAYMENTS_BY_CONTRACT_ID,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function createPaymentTaxAmount(context, payload) {
  // console.log('Add Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
  }
  try {
    await apolloClient
      .mutate({
        mutation: CREATE_PAYMENT_TAX_AMOUNT,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function createPaymentContractFee(context, payload) {
  // console.log('Add Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
  }
  try {
    await apolloClient
      .mutate({
        mutation: CREATE_PAYMENT_CONTRACT_FEE,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function createReceipts(context, payload) {
  // console.log('Create Receipts...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: CREATE_RECEIPTS,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function uploadFile(context, payload) {
  // console.log('Create Receipts...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
    const result = await axios({
      url: config.url.uploads,
      method: 'post',
      headers: {
        'content-type': 'multipart/form-data'
      },
      data: payload.form.formData,
    });

    const {data} = await result;

    return data;
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function getFile(context, payload) {
  // console.log('Get File...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_FILE,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setFile', data.getFile)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getFiles(context) {
  // console.log('Get Files...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_FILES,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setFiles', data.getFiles)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createFile(context, payload) {
  // console.log('Add File...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_FILE,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response
    const {createFile} = data;
    context.commit('addFiles', createFile)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}

export async function updateFile(context, payload) {
  // console.log('Update File...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_FILE,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}

export async function updateFileWithOutAuth(context, payload) {
  // console.log('Update File...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    token: payload.token,
    payload: payload.form
  }

  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_FILE_WITH_OUT_AUTH,
        variables,
        fetchPolicy: 'no-cache'
      })

    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}

export async function deleteFile(context, payload) {
  // console.log('Delete File...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_FILE,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delFile', data.deleteFile)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function toggleTransactionsLoad(context) {
  // console.log('Delete File...')

  context.commit('clearError')
  try {
    context.commit('toggleTransactionsLoad')
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

// ==============================================================
export async function createCallHistory(context, payload) {
  // console.log('Add CallHistory...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CALL_HISTORY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {createCallHistory} = data;
    context.commit('addCallHistories', createCallHistory)
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function deleteCallHistory(context, payload) {
  // console.log('Delete CallHistory...')
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_CALL_HISTORY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delCallHistory', data.deleteCallHistory)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function callHistoriesReceived(context, payload) {
  // console.log('Delete CallHistory...')
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      contractId: payload.contractId
    }
    const response = await apolloClient
      .mutate({
        mutation: CALL_HISTORIES_RECEIVED,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('setCallHistoriesReceived', data.callHistoriesReceived)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function callHistoriesUnReceived(context, payload) {
  // console.log('Get CallHistories UnReceived...')
  context.commit('clearError')
  try {
    const variables = {
      contractId: payload.contractId,
    }
    const response = await apolloClient
      .mutate({
        mutation: CALL_HISTORIES_UN_RECEIVED,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {callHistoriesUnReceived} = data;
    context.commit('setCallHistoriesReceived', callHistoriesUnReceived)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function callHistoriesUnReceivedByUserId(context, payload) {
  context.commit('clearError');
  try {
    const variables = {
      userId: payload.userId
    };
    await apolloClient.mutate({
      mutation: CALL_HISTORIES_UN_RECEIVED_BY_USER_ID,
      variables,
      fetchPolicy: 'no-cache'
    });
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    context.commit('setError', error(e.toString(), null));
  }
}

export async function callHistoriesUnReceivedAll(context) {
  // console.log('Get CallHistories UnReceived All...')
  context.commit('clearError')
  try {
    await apolloClient
      .query({
        query: CALL_HISTORIES_UN_RECEIVED_ALL,
        fetchPolicy: 'no-cache'
      })

    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

// CALL_HISTORIES_UN_RECEIVED_ALL

export async function callHistoriesReceivedByIds(context, payload) {
  // console.log('Delete CallHistory...')
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      userId: payload.userId,
      ids: payload.ids
    }
    await apolloClient
      .mutate({
        mutation: CALL_HISTORIES_RECEIVED_BY_IDS,
        variables,
        fetchPolicy: 'no-cache'
      })
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

// ==============================================================

export async function createSendSmsHistory(context, payload) {
  // console.log('Add SendSmsHistory...')

  context.commit('clearError')

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_SEND_SMS_HISTORY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addSendSmsHistories', data.createSendSmsHistory)

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function deleteSendSmsHistory(context, payload) {
  // console.log('Delete SendSmsHistory...')
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_SEND_SMS_HISTORY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delSendSmsHistory', data.deleteSendSmsHistory)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

// ==============================================================
export async function createSendDocHistory(context, payload) {
  // console.log('Add SendDocHistory...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_SEND_DOC_HISTORY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addSendDocHistories', data.createSendDocHistory)
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function deleteSendDocHistory(context, payload) {
  // console.log('Delete SendDocHistory...')
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_SEND_DOC_HISTORY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delSendDocHistory', data.deleteSendDocHistory)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

// ==============================================================
export async function createLawsuitHistory(context, payload) {
  // console.log('Add LawsuitHistory...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_LAW_SUIT_HISTORY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('addLawsuitHistories', data.createLawsuitHistory)
    context.commit('setSuccess', addItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function deleteLawsuitHistory(context, payload) {
  // console.log('Delete LawsuitHistory...')
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_LAW_SUIT_HISTORY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delLawsuitHistory', data.deleteLawsuitHistory)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

// ==============================================================
export async function getDashboard(context) {
  // console.log('Get File...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_DASHBOARD,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setDashboard', data)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractsByDashboardList(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACTS_BY_DASHBOARD_LIST,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContractsByDashboardList} = await data
    context.commit('setContractsDashboardList', getContractsByDashboardList)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function setContractsByDashboardListFilters(context, payload) {
  context.commit('clearError');
  context.commit('setProcessing', true);

  try {
    context.commit('setSuccess', null);
    context.commit('setContractsDashboardListFilters', payload.form);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractsByNotificationList(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACTS_BY_NOTIFICATION_LIST,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    // console.log(data)
    context.commit('setContractsNotificationList', data.getContractsByNotificationList)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function setContractsByNotificationListFilters(context, payload) {
  context.commit('clearError');
  context.commit('setProcessing', true);

  try {
    context.commit('setSuccess', null);
    context.commit('setContractsNotificationListFilters', payload.form);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getSuretyDetail(context, payload) {
  // console.log('Get SuretyDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_SURETY_DETAIL,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getSuretyDetail} = await data

    setTimeout(() => {
      context.commit('setSuretyDetail', getSuretyDetail)
      context.commit('setSuccess', null)
    }, 200);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getSuretyDetailWithOutAuth(context, payload) {
  // console.log('Get SuretyDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id,
      token: payload.form.token,
    }
    const response = await apolloClient
      .query({
        query: GET_SURETY_DETAIL_WITH_OUT_AUTH,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getSuretyDetailWithOutAuth} = await data

    context.commit('setSuretyDetailWithOutAuth', getSuretyDetailWithOutAuth)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getSuretyDetails(context) {
  // console.log('Get SuretyDetails...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_SURETY_DETAILS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    context.commit('setSuretyDetails', data.getSuretyDetails)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createSuretyDetail(context, payload) {
  // console.log('Add SuretyDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: CREATE_SURETY_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}

export async function updateSuretyDetail(context, payload) {
  // console.log('Update SuretyDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }
  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_SURETY_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}

export async function deleteSuretyDetail(context, payload) {
  // console.log('Delete SuretyDetail...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_SURETY_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delSuretyDetail', data.deleteSuretyDetail)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

// ==============================================================
// getContractIdsSignInStudentApp
export async function getContractIdsSignInStudentApp(context) {
  // console.log('Get ContractIdsSignInStudentApp...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: CONTRACT_IDS_SIGN_IN_STUDENT_APP,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {contractIdsSignInStudentApp} = await data
    context.commit('setContractIdsSignInStudentApp', contractIdsSignInStudentApp)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createQrPayment(context, payload) {
  // console.log('Add QrPayment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  // const vm = payload.vm
  const variables = {
    contractId: payload.contractId,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_QR_PAYMENT,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {createQrPayment} = data
    context.commit('setQrPayment', createQrPayment)
    context.commit('setSuccess', null);
    return true
  } catch (e) {
    context.commit('setError', error(null, null))
    return e
  }
}
